import {action, override, makeObservable} from 'mobx';
import {Collection} from '../../Common/stores/Collection';
import {ContainersField} from './ContainersField';

export class ContainersCollection extends Collection {
    fieldsToShow;
    reportsToShow;

    constructor(parent) {
        super(parent);
        makeObservable(this);
        this.reportsToShow = {};
        this.fieldsToShow = [];
    }

    insertFields(parent, children, fieldsToShow?) {
        this.fields.clear();
        fieldsToShow && this.parseFieldToShow(fieldsToShow);

        children.forEach(f => {
            const newField = new ContainersField(f, parent);
            newField.setCollection(f);
            this.fields.push(newField);
        });
    }

    parseFieldToShow(data) {
        data.forEach((item, index) => {
            const reportId = item.id && item.id.split('.')[0];
            const columnId = item.id && item.id.split('.')[1];
            const isParentExsists = this.reportsToShow.hasOwnProperty(reportId);

            const currentParentObject = {
                parentId: null,
                title: item.title,
                id: item.id,
                value: reportId,
                label: item.repTitle,
                children: {}
            };

            if (!isParentExsists) {
                this.reportsToShow[reportId] = currentParentObject;
            }

            const currentChildObject = {
                parentId: reportId,
                title: item.title,
                id: item.id,
                value: columnId,
                label: item.colTitle,
                children: {}
            };
            this.reportsToShow[reportId].children[columnId] = currentChildObject;
        });
    }

    @action
    createNewField(data, parentField) {
        return new ContainersField(data, parentField);
    }

    @override
    addField(field) {
        this.fields.push(field);
    }
}
